import { render, staticRenderFns } from "./Simple.vue?vue&type=template&id=d38498f4"
import script from "./Simple.vue?vue&type=script&lang=js"
export * from "./Simple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d38498f4')) {
      api.createRecord('d38498f4', component.options)
    } else {
      api.reload('d38498f4', component.options)
    }
    module.hot.accept("./Simple.vue?vue&type=template&id=d38498f4", function () {
      api.rerender('d38498f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/js/components-wa/PageFooter/Simple.vue"
export default component.exports